import { DATA_SELECTOR_ID } from "../utils/context-layer-variables";
const STORE_CONTEXT_LAYER_ERROR = 'store-context-layer-error';
const STORE_SEARCH_ERROR = 'store-search-error';
export function insertErrorMessage(storeSearchContainer, message) {
  const errorContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_CONTEXT_LAYER_ERROR}"]`);
  if (errorContainer) {
    errorContainer.innerHTML = message;
    handleErrorContainerDisplay(storeSearchContainer, true);
  }
}
export function clearErrorMessage(storeSearchContainer) {
  handleErrorContainerDisplay(storeSearchContainer, false);
}
function handleErrorContainerDisplay(storeSearchContainer, showErrorContainer) {
  const storeSearchErrorContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_ERROR}"]`);
  if (storeSearchErrorContainer) {
    storeSearchErrorContainer.classList.remove(showErrorContainer ? 'kl-hidden' : 'kl-visible');
    storeSearchErrorContainer.classList.add(showErrorContainer ? 'kl-visible' : 'kl-hidden');
  }
}
export function getGeolocateErrorMessage(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return context_layer.i18n.geolocate_permission_error;
    case error.POSITION_UNAVAILABLE:
      return context_layer.i18n.geolocate_position_error;
    case error.TIMEOUT:
      return context_layer.i18n.geolocate_timeout_error;
    default:
      return context_layer.i18n.geolocate_unknown_error;
  }
}